<template>
  <div
    v-editable="blok"
    class="Wysiwyg layout-container"
    :class="[desktopWidth('sm'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <ReadMore
      v-if="blok.readMore"
      :show-in-storyblok="true"
      :max-height="readMoreHeight"
      :bg-color="readMoreBg"
      :center-text="blok.centerText || false"
    >
      <div
        class="wysiwyg"
        :class="{
          'text-center': blok.centerText
        }"
      >
        <ExtendedWysiwyg :content="props.blok.content" />
      </div>
    </ReadMore>
    <div
      v-else
      class="wysiwyg"
      :class="{
        'text-center': blok.centerText
      }"
    >
      <ExtendedWysiwyg
        :content="props.blok.content"
        :center-text="blok.centerText || false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';
import ExtendedWysiwyg from '~/components/globals/ExtendedWysiwyg.vue';
import { ISbRichtext } from 'storyblok-js-client';
import ReadMore from '~/components/generic/ReadMore.vue';

interface Props {
  content: ISbRichtext,
  readMore: boolean,
  readMoreHeight: string,
  centerText?: boolean,
}

const props = defineProps<{
  blok: Props,
}>();

const { $toNumber } = useNuxtApp();
const readMoreHeight = computed(()=> {
  return props.blok.readMoreHeight ? $toNumber(props.blok.readMoreHeight) : 100;
});

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

const readMoreBg = computed(()=> {
  switch (props.blok.visualAppearance.backgroundColor) {
    case 'bg-bg-subtle':
      return '#FCF9F5';
    case 'bg-bg-secondary':
      return '#F0EAE4';
    case 'bg-bg-accenture':
      return '#F0DDD8';
  }
  return '#FFFFFF';
});

</script>